import { Dimensions } from 'react-native'

export enum ViewportInstance {
  screen = 'screen',
  window = 'window',
}

export const screenHeight = Dimensions.get(ViewportInstance.screen).height
export const screenWidth = Dimensions.get(ViewportInstance.screen).width
export const windowHeight = Dimensions.get(ViewportInstance.window).height
export const windowWidth = Dimensions.get(ViewportInstance.window).width

export const loginButtonRadius = 100
